/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react'
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import { useDispatch, useSelector } from "react-redux";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { NavLink } from "react-router-dom";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import roleActions from "../../../../YounoteAdmin/SecuritySetup/redux/actions";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg"
import { Row, Col, Image, Space } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { TeamTable } from "./TeamTable";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { toast } from 'react-toastify';
import CustomAlert from "../../../../Shared/components/CustomAlert";
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation, customPhoneValidation, customAlaphabetValidation, customEmailValidation } from "../../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { checkCRUDPermission, checkComponentPermission, getUserId, getRoleId, idNamingConversion } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const Team = (props) => {
    const { getTeamList, getTeamLoader, getTeamData, subscriptionDetails } = useSelector(state => state.homeReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { roleDetails } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const { createDetails, createError, createLoader } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [fullName, setFullName] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [emailId, setEmailId] = useState('');
    const [roles, setRoles] = useState('');
    const [errorName, setErrorName] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorRole, setErrorRole] = useState(false);
    const [errorCommon, setErrorCommon] = useState(false);

    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 50;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const [importVisible, setImportVisible] = useState(false);

    const handleOpen = () => {
        setVisible(true);
    };
    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const emptyState = () => {
        setErrorName(false);
        setErrorMobile(false);
        setErrorEmail(false);
        setErrorRole(false);
        setErrorCommon(false);
    }

    const emptyStateInput = () => {
        setFullName('');
        setMobileNo('');
        setEmailId('');
        setRoles('');
    }

    const dispatch = useDispatch();
    const createTeam = (e) => {
        e.preventDefault();
        let emptyName = customAlaphabetValidation('Full Name', fullName);
        let emptyMobile = customPhoneValidation('Mobile', mobileNo, 10);
        let emptyEmail = customEmailValidation('Email', emailId);
        let emptyRole = emptyValidation('Role', roles);
        emptyState();
        if (emptyName.isValid && emptyMobile.isValid && emptyEmail.isValid && emptyRole.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'team/user',
                title: "Team member",
                details: {
                    name: fullName,
                    email: emailId,
                    mobile: mobileNo,
                    roleId: roles
                }
            });
        } else {
            if (emptyName.errors !== '') {
                setErrorName(emptyName.errors);
            } if (emptyMobile.errors !== '') {
                setErrorMobile(emptyMobile.errors);
            } if (emptyEmail.errors !== '') {
                setErrorEmail(emptyEmail.errors);
            } if (emptyRole.errors !== '') {
                setErrorRole(emptyRole.errors);
            }
        }
    }

    const prevGetData = usePrevious(getTeamData);
    useEffect(() => {
        if (loadMore && getTeamData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getTeamData && prevGetData !== getTeamData) {
            const timer = setTimeout(() => {
                if (getTeamData && Array.isArray(getTeamData) && getTeamData.length > 0) {
                    setLoadMore(true);
                    if (getTeamData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getTeamData]);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    // useEffect(() => {
    //     if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
    //         if (timeoutRef.current !== null) {
    //             clearTimeout(timeoutRef.current);
    //         }
    //         if (search === '') {
    //             dispatchFilter(sortBy, sortOrder);
    //         } else {
    //             timeoutRef.current = setTimeout(() => {
    //                 timeoutRef.current = null;
    //                 dispatchFilter(sortBy, sortOrder);
    //             }, 500);
    //         }
    //     }
    // }, [search]);

    useEffect(() => {
        loadTasks();
    }, []);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ email: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ status: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: actions.TEAM_DETAILS_START,
            url: 'team',
            skip: skip,
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast('Team Created Successfully');
            emptyStateInput();
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            let error = message.split("|");
            if (error[0] === 'mobile') {
                setErrorMobile(error[1]);
            } else if (error[0] === 'email') {
                setErrorEmail('Email already exits');
            } else {
                setErrorCommon(message);
            }
        }
    }, [createDetails, createError]);

    const loadTasks = useCallback(() => {
        dispatch({
            type: roleActions.ROLE_DETAILS_START, filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(sortBy, sortOrder);
    });

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.TEAM_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'team',
            filter: {
                order: sortBy + ' ' + sortOrder
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader   {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Team Management', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableTeamManagement)}>
                <PrimaryCard
                    title={'Team Management'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Team Management', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                id={idNamingConversion('Search', 'teamManagement', 'TextField')}
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Team Management', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'teamManagement', 'Link')}
                                                    onClick={() => { loadImportExportData('TeamUser'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {/* {
                                                roleManagement !== '' && checkComponentPermission('Team Management', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            } */}
                                            {
                                                roleManagement !== '' && checkComponentPermission('Team Management', 'Action', 'Buy License') &&
                                                <NavLink
                                                    to={'/admin/home/billings'}
                                                    id={idNamingConversion('Upgrade', 'teamManagement', 'Link')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Upgrade</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Team Management', 'create', 'Admin') &&
                                                getTeamList && subscriptionDetails?.plan?.allowedUsers > getTeamList?.length &&
                                                <NavLink
                                                    to={'#'}
                                                    id={idNamingConversion('Add New User', 'teamManagement', 'Link')}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add New User</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <div className={classes.marginBottom20}>
                                {getTeamList && getTeamList?.length}/{subscriptionDetails?.plan?.allowedUsers} User License Used
                                {getTeamList && getTeamList?.length >= subscriptionDetails?.plan?.allowedUsers ?
                                    <span className={clsx(classes.userLimit)}> <span className={classes.colorRed}>User Limit Reached.</span>
                                        <NavLink to={'/admin/home/billings'}
                                            id={idNamingConversion('Add More Users', 'teamManagement', 'Link')}
                                            className={clsx(classes.color, classes.bold)}>Click here</NavLink> to Add More Users</span> : ''}
                            </div>
                            <TeamTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getTeamList}
                                userId={getUserId()}
                                roleId={getRoleId()}
                                loadMore={loadMore}
                                roleDetails={roleDetails}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                roleManagement={roleManagement}
                                search={search}
                                customObject={(details, id) => customObject(details, id)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'New Team Member'}
                    width={"360px"}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createTeam(e)}>
                            <div className={classes.customFormFlex}>
                                {errorCommon && <CustomAlert error={errorCommon} customClass={clsx(classes.uploadError, classes.margin10t)} />}
                                <TextField autoComplete='one-time-code'
                                    label={["Full Name ", <span key={'Full Name'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorName && true}
                                    helperText={errorName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    id={idNamingConversion('Full Name', 'teamManagement', 'TextField')}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setFullName(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Mobile Number ", <span key={'Mobile Number'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorMobile && true}
                                    helperText={errorMobile}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    id={idNamingConversion('Mobile Number', 'teamManagement', 'TextField')}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setMobileNo(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Email Id ", <span key={'Email Id'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorEmail && true}
                                    helperText={errorEmail}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    id={idNamingConversion('Email Id', 'teamManagement', 'TextField')}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setEmailId(e.target.value)}
                                />
                                <AutoCompleteComponent
                                    name={["Role ", <span key={'Role'} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Role Name' }]}
                                    details={roleDetails}
                                    id={idNamingConversion('Role', 'teamManagement', 'DropDown')}
                                    parentValue={customObject(roleDetails, roles)}
                                    onChange={(data) => setRoles(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                    parentError={errorRole}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    id={idNamingConversion('Save', 'teamManagement', 'Button')}
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                                    Save
                                </Button>
                            </div>
                        </Box>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'TeamUser'}
                type={'import'}
                loader={getTeamLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={getTeamList}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}

export default Team